import { centerCenterCss, flexRootCss, verticalCss } from "@snapchat/emotion-helpers";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const fullWidthCss = css({
    width: "100%",
});

export const fullHeightCss = css({
    height: "100%",
});

export const fullWidthAndHeightCss = css(fullWidthCss, fullHeightCss);

export const FailedContainer = styled.div`
    ${fullWidthAndHeightCss}
    ${flexRootCss}
    ${verticalCss}
    ${centerCenterCss}
`;

export const StyledContent = styled.div`
    width: 100%;
    padding-bottom: 100px;
    border: none;
`;
